import { axiosInstance, getErrorStatus } from './axiosInstance';
import { StatusCodes } from 'http-status-codes';

export const getCapitalFacility = async (businessId, applicationId) => {
  let response;

  response = await axiosInstance.get(`/capital-facility/${businessId}/${applicationId}`);

  if (response.status !== StatusCodes.OK || !response.data) {
    throw new Error('GetCapitalFacilityDetailsError');
  }

  return response.data;
};

export const getTransactionDetails = async (businessId, id) => {
  let response;

  try {

    response = await axiosInstance.get(`capital-facility/${businessId}/transactions/${id}`);

    if (response.status !== StatusCodes.OK || !response.data) {
      throw new Error('GetCapitalFacilityTransactionHistoryError');
    }
  } catch (error) {
    const status = getErrorStatus(error);
    if (status === StatusCodes.NOT_FOUND) {
      return { records: [] };
    }
    throw error;
  }

  return response.data;
};

export const getTransactions = async (businessId) => {
  let response;

  try {

    response = await axiosInstance.get(`/capital-facility/${businessId}/transactions`);

    if (response.status !== StatusCodes.OK || !response.data) {
      throw new Error('GetCapitalFacilityTransactionHistoryError');
    }
  } catch (error) {
    const status = getErrorStatus(error);
    if (status === StatusCodes.NOT_FOUND) {
      return [];
    }
    throw error;
  }

  return response.data;
};

export const getWithdrawalQuote = async (amount, businessId, applicationId) => {
  let response;

  try {

    response = await axiosInstance.get(`/capital-facility/${businessId}/withdrawal-quote/${applicationId}?amount=${amount};`);

    if (response.status !== StatusCodes.OK || !response.data) {
      throw new Error('GetCapitalFacilityTransactionHistoryError');
    }
  } catch (error) {
    const status = getErrorStatus(error);
    if (status === StatusCodes.BAD_REQUEST) {
      return null;
    }

    throw error;
  }

  return response.data;
};

export const increaseCapitalFacilityLimit = async (id, amount, businessId, appId) => {
  let response;

  response = await axiosInstance.post('/capital-facility/limit-increase', { id, amount, businessId, appId });

  if (response.status !== StatusCodes.ACCEPTED || !response.data) {
    throw new Error('IncreaseCapitalFacilityLimitError');
  }

  return response.data;
};

export const postCapitalFacilityWithdrawalQuote = async (amount, businessId, applicationId) => {

  let response;
  try {

    response = await axiosInstance.post(`/capital-facility/${businessId}/withdrawal-quote/${applicationId}`, { amount });
    if (response.status !== StatusCodes.CREATED || !response.data) {
      throw new Error('WithdrawlError');
    }
  } catch (error) {
    const status = getErrorStatus(error);
    if (status === StatusCodes.BAD_REQUEST) {
      return null;
    }

    throw error;
  }

  return response.data;
};
